import React, { ReactElement } from 'react';
import type { Route } from 'next';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Benefits/MemberDirectory/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Benefits', href: '/benefits' as Route },
            { title: 'Member Directory', href: '' as Route },
          ]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__title-box')}>
            <h1 className={cn('header__title')}>
              Global Freight Forwarders List & Directory
            </h1>
            <p className={cn('header__title-description')}>
              The logistics world has never been short on complexity, but finding a trusted
              freight forwarder shouldn’t be a wild goose chase. Whether you're shipping
              across continents or moving goods within a region, the DF Alliance Member
              Directory simplifies the search for reliable partners.
            </p>
            <p className={cn('header__title-description')}>
              It’s not just a list it’s a bridge to vetted professionals who know how to
              keep cargo moving, no matter what.
            </p>
          </div>
          {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
          {/* <div className={cn('header__buttons')}>
            <Link className={cn('header__button-join')} href="/membership">
              Join DF Alliance
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;